import React from 'react'

import { getMediaUrl, handleImageError } from '../../utils/helpers'

const imageTypes = {
    lg: 'user-28x28',
    xl: 'user-photo-60x60',
}

interface UserPartProps {
    src?: string | undefined | null
    name?: string
    email?: string
    size?: keyof typeof imageTypes
}

const UserPart = ({ src, name, email, size = 'lg' }: UserPartProps) => {
    return (
        <div className="flex items-center gap-8">
            {src && (
                <div className={`${imageTypes[size]}`}>
                    <img
                        style={{ minHeight: '100%', minWidth: '100%' }}
                        src={getMediaUrl(src)}
                        alt={name || 'not specified'}
                        onError={(e) => handleImageError(e)}
                    />
                </div>
            )}
            {(name || email) && (
                <div className="flex flex-col">
                    {name && <span className="text--xs fw-500">{name}</span>}
                    {email && (
                        <span className="text--12 text-color-1">{email}</span>
                    )}
                </div>
            )}
        </div>
    )
}

export default UserPart
